import { Language } from '@cirklo/client';
import { createAction, props } from '@ngrx/store';

const prefix = '[Dashboard]';

export const setActiveLanguage = createAction(`${prefix} Set language`, props<{ language: Language }>());
